export function formatAsCurrency(value = 0) {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) {
    throw new Error(`"${value}" need to be a number to be formated as currency`);
  }
  return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}
